




















import { Component, Vue, Prop, Emit } from "vue-property-decorator";

@Component
export default class ConfirmModal extends Vue {
  @Prop() title: string;
  @Prop() content: string;
  @Prop({ default: "Confirm" }) confirmText: string;
  @Prop({ default: "Cancel" }) cancelText: string;
  @Prop({ default: false }) danger: boolean;

  dialog: boolean = false;

  open() {
    this.dialog = true;
  }
  close() {
    this.dialog = false;
  }

  @Emit("confirm")
  async onConfirm() {
    this.close();
  }

  @Emit("close")
  async onClose() {
    this.close();
  }
}
